import { css } from 'styled-components';

// V5: Using Google Fonts (Inter + JetBrains Mono) loaded via CDN
// No local font files needed — fonts loaded in head.js via link tags
// Keeping this file for compatibility with the GlobalStyle import

const Fonts = css``;

export default Fonts;
